import { DataService } from 'src/app/services/data.service';
import { BreadCrumb } from './../../../../interfaces/main';
import { Lightbox } from 'ngx-lightbox';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  private _albums = [];

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'Gallery'
  }]

  constructor(
    private _lightbox: Lightbox,
    private data: DataService
  ) {}

  ngOnInit() {
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        this._albums = _.map(res.data.images, (v, i) => {
          return {
            src: v.src,
            image: `Image #${i}`,
            thumb: v.src
          }
        })
      }
    })
  }

  open(index: number): void {
    this._lightbox.open(this._albums, index);
  }

}
